import service from '../index';

function prependSelecione(element) {
  return {
    ...element,
    formas: [{ value: null, text: 'Selecione' }, ...element.formas],
  };
}

function getValor(element, dadosFinanceiros) {
  if (!dadosFinanceiros) return null;

  const { isMensal, nomeProduto } = element;
  const produtos = isMensal
    ? dadosFinanceiros.mensais
    : dadosFinanceiros.avista;

  const produto = produtos.find(
    ({ nomeProduto: nome }) => nome === nomeProduto,
  );

  return produto ? produto.valor : null;
}

function cartaoSelecionado(cartoes, campo) {
  const cartaoAssociado = cartoes.find((cartao) => cartao[campo]);
  return cartaoAssociado ? cartaoAssociado.id_associado_cartao : null;
}

function separaListaProdutosMensaisEAvista(formasPagamento, isMensal = false) {
  return formasPagamento
    .filter((formaPagamento) => formaPagamento.isMensal === isMensal)
    .map(prependSelecione);
}

export async function normalizaObjFormasPagamento(
  acao,
  dadosProposta,
  dadosFinanceiros,
  naoExibeTodasFormasPagameto = false,
) {
  const { idEmpresa, idProposta, idProspect, produtos, regional } =
    dadosProposta;

  const { data } = await service.post('CotacaoAberta', acao, {
    idEmpresa,
    idProposta,
    idProspect,
    produtos,
    regional,
    naoExibeTodas: naoExibeTodasFormasPagameto,
  });

  if (!data) {
    throw new Error('Erro ao buscar formas de pagamento');
  }

  const { cartoes, formasPagamento } = data;

  const cartaoSelecionadoMensalidade = cartaoSelecionado(
    cartoes,
    'selecionado',
  );

  const cartaoSelecionadoAdesao = cartaoSelecionado(
    cartoes,
    'selecionadoAdesao',
  );

  const formasPagamentoAux = formasPagamento.reduce((acc, element, index) => {
    const valor = getValor(element, dadosFinanceiros);

    if (
      index !== 0 &&
      element.nomeProduto === formasPagamento[index - 1].nomeProduto
    ) {
      const existeFormaPagamento = acc[acc.length - 1].formas.find(
        ({ value }) =>
          value.idTipoPagamentoEmpresa === element.id_tipoPagamentoEmpresa,
      );

      if (existeFormaPagamento) {
        return acc;
      }

      acc[acc.length - 1].formas.push({
        value: {
          idTipoPagamentoEmpresa: element.id_tipoPagamentoEmpresa,
          tipoPagamento: element.nomePagamento,
        },
        text: element.nomePagamento,
      });
      return acc;
    }

    acc.push({
      idProduto: element.idProduto,
      idTipoProduto: element.idTipoProduto,
      nomeProduto: element.nomeProduto,
      isMensal: element.isMensal,
      valor,
      formas: [
        {
          value: {
            idTipoPagamentoEmpresa: element.id_tipoPagamentoEmpresa,
            tipoPagamento: element.nomePagamento,
          },
          text: element.nomePagamento,
        },
      ],
    });

    return acc;
  }, []);

  const listaProdutosMensais = separaListaProdutosMensaisEAvista(
    formasPagamentoAux,
    true,
  );

  const listaProdutosAAvista =
    separaListaProdutosMensaisEAvista(formasPagamentoAux);

  return {
    listaProdutosMensais,
    listaProdutosAAvista,
    cartaoSelecionadoMensalidade,
    cartaoSelecionadoAdesao,
    cartoes,
    formasPagamento,
  };
}
